import { createTheme } from '@mui/material/styles';

interface createHeaderThemeProps {
	headerTextColor: string;
headerBgsBtns: string;
}

const createHeaderTheme = (colors: createHeaderThemeProps) => {
return createTheme({
	components: {
		MuiOutlinedInput: {
			styleOverrides: {
			root: {
				'& fieldset': {
				borderColor: `#${colors.headerTextColor}`, // Adjusted for dynamic color
				},
				'&:hover fieldset': {
				borderColor: `#${colors.headerTextColor} !important`, // Adjusted for dynamic color
				},
				'&.Mui-focused fieldset': {
				borderColor: `#${colors.headerTextColor} !important`, // Adjusted for dynamic color
				},
				'& .MuiInputBase-input': {
				color: `#${colors.headerTextColor}`, // Here's where we set the text color
				},
			},
			},
		},
		MuiSelect: {
			styleOverrides: {
				select: {
					color: `#${colors.headerTextColor}`, // Adjusted for dynamic text color inside the Select
				},
				icon: {
					color: `#${colors.headerTextColor}`, // Adjusted for dynamic dropdown icon color
				},
			},
		},
		MuiButton: {
			styleOverrides: {
				root: {
					color: `#${colors.headerTextColor}`, // Set the text color
					borderColor: `#${colors.headerTextColor}`, // Set the border color
					backgroundColor: `#${colors.headerBgsBtns}`, // Set the background color for contained variant
					'&:hover': {
						backgroundColor: darkenColor(colors.headerBgsBtns, 0.1), // Slightly darken the color on hover
						borderColor: `#${colors.headerTextColor}`, // Ensure border color on hover
					},
				},
				contained: {
					borderColor: `#${colors.headerTextColor}`, // Ensure the border color is also set for contained buttons
					borderWidth: '1px', // Ensure the border width is set
					borderStyle: 'solid', // Ensure the border style is set
					backgroundColor: `#${colors.headerBgsBtns}`, // Set the background color for contained variant
					'&:hover': {
						backgroundColor: darkenColor(colors.headerBgsBtns, 0.1), // Slightly darken the color on hover
						borderColor: `#${colors.headerTextColor}`, // Ensure border color on hover
					},
				},
				outlined: {
					borderColor: `#${colors.headerTextColor}`, // Ensure the border color is also set for outlined buttons
				},
			},
		},
		MuiSvgIcon: {
			styleOverrides: {
			root: {
				color: `#${colors.headerTextColor}`, // Adjusted for dynamic SvgIcon color
			},
			},
		},
		MuiInputLabel: {
			styleOverrides: {
			root: {
				color: `#${colors.headerTextColor}`, // Normal state
				'&.Mui-focused': {
				color: `#${colors.headerTextColor || colors.headerTextColor}`, // Focused state
				},
			},
			},
		},
		MuiTypography: {
			styleOverrides: {
				root: {
					color: `#${colors.headerTextColor}`, // Set the text color for Typography components
				},
			},
		},
	}
});
};

const darkenColor = (hexColor: string, amount: number) => {
    let color = hexColor.startsWith('#') ? hexColor.slice(1) : hexColor;
    const num = parseInt(color, 16);
    let r = (num >> 16) - Math.floor(amount * 255);
    let g = ((num >> 8) & 0x00FF) - Math.floor(amount * 255);
    let b = (num & 0x0000FF) - Math.floor(amount * 255);

    r = Math.max(0, Math.min(255, r));
    g = Math.max(0, Math.min(255, g));
    b = Math.max(0, Math.min(255, b));

    return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase()}`;
};

export default createHeaderTheme;